export interface GetAccountApprovalsPreference {
  preference?: string
  flow?: string
  parentId: string
}

export interface UpdateAccountApprovalsPreference {
  preference?: string
  flow?: string
  parentId: string
  enabled: boolean
}

export interface AccountApprovalsPreferenceError {
  code: string
  data: { code: string; error: string; message: string; status: number }
  errorList: unknown
  message: string
  status: number
}

export interface ApprovalWorkflowActionPreRequest {
  action: 'APPROVE' | 'REJECT'
  reference: string[]
  reason?: string
}

export interface ApprovalOperationChallengeRequest {
  challenge: string
  tokenResponse: string
}

export interface ApprovalWorkflowActionResponse {
  code?: string
  data?: {
    challenge: {
      value: string
      type: string
      ttl: string
    }
    callbackUrl: string
    context: {
      code: string
      message: string
    }
  }
  message?: string
  status?: number
}

export interface UpdateAccountAprrovers {
  updateUserRoleGroups: {
    emailAddress: string
    approver: boolean
  }[]
}

export interface PendingTransactionsResponse {
  correlationKey: string
  status: keyof typeof ApprovalStatuses
  amount: string
  type: string
  currency: {
    code: string
    name: string
  }
  fiatWithdrawalDetails: {
    bankCode: string
    accountNumber: string
    beneficiaryName: string
  }
  walletName: string
  initiatedBy: string
  actionedBy: string
  payOutReference: string
  initiatedAt: string
  actionedAt: string
  rejectionReason: string
}

export const ApprovalStatuses = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
}
